module.exports = __webpack_public_path__ + "static/media/boat-img-19.3cf9c393.jpg";